var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"home"},[(_vm.units.length > 0 )?_c('ReportTable',{attrs:{"units":_vm.units}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }